export class ServiceUnavailableError extends Error {
    constructor() {
        super("Service unavailable (503)");
        Object.setPrototypeOf(this, ServiceUnavailableError.prototype);
    }
}